/*
import reportWebVitals from './reportWebVitals';
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
*/

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ConfigProvider } from './ConfigProvider';


ReactDOM.render(
    <ConfigProvider>
      <App isTest={false} />
    </ConfigProvider>,
    document.getElementById('root')
  );